import { keyframes, css } from "styled-components";

// Animation keyframes
export const animationKeyframes = {
  fadeIn: keyframes`
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  `,
  fadeInOut: keyframes`
    0% {
      opacity: 0.2;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0.2;
    }
  `,
  fadeInBox: keyframes`
    from {
      opacity: 0;
      backdrop-filter: blur(0);
    }
    to {
      opacity: 1;
      backdrop-filter: blur(8px);
    }
  `,
  scaleIn: keyframes`
    from {
      transform: scale(0.8);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  `,
  spin: keyframes`
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  `,
  glowPulse: keyframes`
    0% {
      text-shadow:
        0 0 2px #fff,
        0 0 4px #fff,
        0 0 6px #fff,
        0 0 10px var(--glow-color),
        0 0 45px var(--glow-color),
        0 0 55px var(--glow-color),
        0 0 70px var(--glow-color),
        0 0 80px var(--glow-color);
    }
    100% {
      text-shadow:
        0 0 4px #fff,
        0 0 11px #fff,
        0 0 19px #fff,
        0 0 40px var(--glow-color),
        0 0 80px var(--glow-color),
        0 0 90px var(--glow-color),
        0 0 100px var(--glow-color),
        0 0 150px var(--glow-color);
    }
  `,
  buttonGlowPulse: keyframes`
    0% {
      box-shadow: none;
    }
    50% {
      box-shadow: 0 0 20px rgba(65, 164, 217, 0.9),
                  0 0 40px rgba(65, 164, 217, 0.7),
                  0 0 60px rgba(65, 164, 217, 0.5);
    }
    100% {
      box-shadow: none;
    }
  `,
  blendIn: keyframes`
    from {
      opacity: 0;
      backdrop-filter: blur(0);
      background: rgba(255, 255, 255, 0);
    }
    to {
      opacity: 1;
      backdrop-filter: blur(8px);
      background: rgba(255, 255, 255, 1);
    }
  `,
  slideInLeft: keyframes`
    from {
      transform: translateX(-100%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  `,
  qrScanner: keyframes`
    0% {
      transform: translate(-50%, -50%) scale(0.8);
      opacity: 0;
    }
    50% {
      transform: translate(-50%, -50%) scale(1.1);
      opacity: 0.7;
    }
    100% {
      transform: translate(-50%, -50%) scale(1);
      opacity: 1;
    }
  `,
  qrMoveToPosition: keyframes`
    0% {
      transform: translate(-50%, -50%) rotate(0deg);
    }
    20% {
      transform: translate(-50%, -50%) rotate(180deg);
    }
    40% {
      transform: translate(-50%, -50%) rotate(360deg);
    }
    60% {
      transform: translate(-50%, -50%) rotate(540deg);
    }
    80% {
      transform: translate(-50%, 20%) rotate(720deg);
    }
    90% {
      transform: translate(-50%, -10%) rotate(720deg);
    }
    100% {
      transform: translate(-50%, 0) rotate(720deg);
    }
  `,
  qrSpinDown: keyframes`
    0% {
      transform: translate(-50%, 0) rotate(720deg);
    }
    100% {
      transform: translate(-50%, 100%) rotate(1080deg);
      opacity: 0;
    }
  `,
  qrGrowAndBlend: keyframes`
    0% {
      transform: translate(-50%, 0) scale(1);
      opacity: 1;
    }
    50% {
      transform: translate(-50%, 0) scale(2);
      opacity: 0.5;
    }
    100% {
      transform: translate(-50%, 0) scale(2.5);
      opacity: 0;
    }
  `,
};

// Animation configurations
export const animations = {
  verificationBox: {
    keyframe: animationKeyframes.blendIn,
    duration: "0.6s",
    timing: "ease-out",
    delay: "0.2s",
  },
  leftSection: {
    keyframe: animationKeyframes.slideInLeft,
    duration: "0.8s",
    timing: "ease-out",
    delay: "0.6s",
  },
  qrScanner: {
    keyframe: animationKeyframes.qrScanner,
    duration: "0.8s",
    timing: "cubic-bezier(0.34, 1.56, 0.64, 1)",
    delay: "1.4s",
    iterationCount: Math.floor(Math.random() * 3) + 0,
  },
  qrSpinDown: {
    keyframe: animationKeyframes.qrSpinDown,
    duration: "1s",
    timing: "cubic-bezier(0.34, 1.56, 0.64, 1)",
    delay: "0s",
  },
  mobileContentCard: {
    keyframe: animationKeyframes.fadeIn,
    duration: "0.6s",
    timing: "ease-out",
    delay: "2.2s", // 1.4s QR delay + 0.8s QR duration
  },
  rightContent: {
    keyframe: animationKeyframes.fadeIn,
    duration: "0.6s",
    timing: "ease-out",
    delay: "0.26s",
  },
  checkmark: {
    keyframe: animationKeyframes.scaleIn,
    duration: "0.65s",
    timing: "ease-out",
    delay: "1.2s",
  },
  content: {
    keyframe: animationKeyframes.fadeIn,
    duration: "0.39s",
    timing: "ease-out",
    delay: "1.6s",
  },
  mainMessage: {
    keyframe: animationKeyframes.fadeIn,
    duration: "0.4s",
    timing: "ease-out",
    delay: "0.2s",
  },
  thankYouMessage: {
    keyframe: animationKeyframes.fadeIn,
    duration: "0.4s",
    timing: "ease-out",
    delay: "0.6s",
  },
  productDetails: {
    keyframe: animationKeyframes.fadeIn,
    duration: "0.4s",
    timing: "ease-out",
    delay: "1.0s",
  },
  qrGrowAndBlend: {
    keyframe: animationKeyframes.qrGrowAndBlend,
    duration: "1s",
    timing: "cubic-bezier(0.34, 1.56, 0.64, 1)",
    delay: "0s",
  },
};

// Helper function to create animation string
export const createAnimation = (config) => css`
  ${config.keyframe} ${config.duration} ${config.timing} forwards
`;
